// src/components/Footer.jsx
import React from 'react';
import { Github, Linkedin, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { name: 'GitHub', icon: <Github size={18} />, url: 'https://github.com/sohamXzayn' },
    { name: 'LinkedIn', icon: <Linkedin size={18} />, url: 'https://www.linkedin.com/in/soham-hasan-707691309/' },
    { name: 'Email', icon: <Mail size={18} />, url: 'mailto:work4soham@gmail.com' },
    { name: 'Facebook', icon: <Facebook size={18} />, url: 'https://www.facebook.com/HeySoham' },
    
  ];

  return (
    <footer className="portfolio-footer" style={{ padding: '30px 20px 20px' }}>
      <div className="footer-content">
        <h2 className="footer-title" style={{ fontSize: '0.75rem', marginBottom: '15px' }}>
          LET'S <span>CONNECT</span>
        </h2>
        
        <div className="social-links-container" style={{ gap: '15px', marginBottom: '20px' }}>
          {socialLinks.map((link, index) => (
            <a 
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label={link.name}
              style={{ padding: '8px' }} // Slightly smaller padding for icons
            >
              {link.icon}
            </a>
          ))}
        </div>

        <p className="footer-copyright" style={{ fontSize: '0.7rem', opacity: 0.6 }}>
          © {new Date().getFullYear()} • Crafted by HeySoham
        </p>
      </div>
    </footer>
  );
};

export default Footer;